import { Box, Card, Checkbox, Text } from '@nimbus-ds/components';
import './TaskCheckboxCard.scss';

interface TaskCheckboxCardProps {
  task: { id: number; code: string; description?: string; label: string };
  checked: boolean;
  onChange: (id: number, checked: boolean) => void;
}

export function TaskCheckboxCard({
  task,
  checked,
  onChange,
}: Readonly<TaskCheckboxCardProps>) {
  return (
    <Card>
      <Card.Header>
        <div className="stratus--checkbox-shadow">
          <Checkbox
            label={task.label}
            name={task.id.toString()}
            checked={checked}
            onChange={(e) => onChange(task.id, e.target.checked)}
          />
        </div>
        {!!task.description && (
          <Box
            paddingLeft="5"
            paddingTop="1"
            data-style="stratus--card-description"
          >
            <Text as="span">{task.description}</Text>
          </Box>
        )}
      </Card.Header>
    </Card>
  );
}
